<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="color"
        stroke-width="2.5"
        stroke-linecap="square"
        stroke-linejoin="round"
    >
        <circle
            cx="12"
            cy="12"
            r="10">
        </circle>
        <rect
            x="9"
            y="9"
            width="6"
            height="6">
        </rect>
    </svg>
</template>
<script>
    export default {
        props: {
            size: { type: [String, Number], default: 22 },
            color: { type: String, default: 'white' }
        }
    }
</script>
